export const USER_TYPE = {
	INTERNAL: 'INTERNAL',
	PARTNER: 'PARTNER',
	CUSTOMER: 'CUSTOMER',
};

export const PRODUCT_NAME = {
	JIRA: 'JIRA',
	CONFLUENCE: 'CONFLUENCE',
} as const;

export const PERMISSION_LEVELS = {
	ADMIN: 'ADMIN',
	NON_ADMIN: 'NON_ADMIN',
} as const;

export type PermissionLevel = (typeof PERMISSION_LEVELS)[keyof typeof PERMISSION_LEVELS];
